import React, { memo } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import { DataTable, SearchPropTypes } from "MODULES/shared/components";

const renderRow = columns => record => (
  <tr key={record.period}>
    {columns.map(column => (
      <td key={column.key}>
        {typeof column.render === "function"
          ? column.render(record)
          : get(record, column.key)}
      </td>
    ))}
  </tr>
);

const Table = memo(({ results = [], isLoading, columns, refresh }) => (
  <DataTable loading={isLoading} loadingRows={3} refresh={refresh}>
    <DataTable.Head>
      {columns.map(column => <th key={column.key}>{column.label}</th>)}
    </DataTable.Head>
    <DataTable.Body>{results.map(renderRow(columns))}</DataTable.Body>
  </DataTable>
));

Table.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      render: PropTypes.func
    })
  ),
  ...SearchPropTypes
};

export default Table;



// WEBPACK FOOTER //
// ./app/modules/HighScores/components/StatsTable/Table.jsx